import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { insuranceDetailInputList, relationOptions } from '../../../../common/data';
import TextField from '../../../../components/common/TextField';

import Typography from '../../../../components/common/Typography';
import DetailButtonSection from '../../../../components/DetailButtonSection';
import { getInsuranceDetail, updateInsuranceInfo } from '../insuranceSlice';
import {
  formatNumber,
  getAlertMessageFunction,
  getTotal,
  handleNumberChange2,
  magamCertifyCheck,
} from '../../../../common/Util';
import SlideRightDialog from '../../../../components/common/SlideRightDialog';
import { setIsDataModified } from '../../../common/commonSlice';

// 보험료(일반) 국세청 : v.htm016
// 보험료(장애) 국세청 : v.htm017
// 보험료(일반) 국세청외 : v.htm018
// 보험료(장애) 국세청외 : v.htm019
const InsuranceDetail = ({ isOpen, onClose }) => {
  const { t } = useTranslation('deductions/insurance');
  const { t: tDependents } = useTranslation('dependents');
  const { t: tCommon } = useTranslation('common');
  const inputList = insuranceDetailInputList(t);
  const { isMagam, isCertify } = useSelector(state => state.common);

  const relationList = relationOptions(tDependents);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [data, setData] = useState({
    htm001: '',
    htm016: '',
    htm017: '',
    htm018: '',
    htm019: '',
  });
  const { insuranceDetail, selectedInsuranceDetail } = useSelector(state => state.insurance);

  useEffect(() => {
    console.log(selectedInsuranceDetail);
    if (selectedInsuranceDetail?.htm001) {
      dispatch(getInsuranceDetail(selectedInsuranceDetail));
    } else {
      onClose();
    }
  }, [selectedInsuranceDetail]);

  useEffect(() => {
    setData({
      ...insuranceDetail,
      total: getTotal([insuranceDetail], ['htm016', 'htm017', 'htm018', 'htm019']),
    });
  }, [insuranceDetail]);

  const handleChange = (e, key) => {
    const value = handleNumberChange2(e.target.value);
    dispatch(setIsDataModified(true));
    setData({ ...data, [key]: value });
  };

  const handleSave = async () => {
    const alertMessage = getAlertMessageFunction();
    if (!magamCertifyCheck(isMagam, isCertify)) {
      return;
    }
    let formData = [
      {
        htm001: data.htm001,
        htm016: data.htm016,
        htm017: data.htm017,
        htm018: data.htm018,
        htm019: data.htm019,
      },
    ];
    try {
      const resultAction = await dispatch(updateInsuranceInfo({ formData })).unwrap();

      if (resultAction.resultCode === 'OK') {
        alertMessage(tCommon('alertMessage.saveSuccess'), 'success');
        onClose();
      } else {
        alertMessage(tCommon('alertMessage.saveFail'), 'error');
      }
    } catch (error) {
      alertMessage(tCommon('alertMessage.saveFail'), 'error');
      console.error('저장 중 오류 발생: ', error);
    }
  };

  const total = useMemo(() => {
    return getTotal([data], ['htm016', 'htm017', 'htm018', 'htm019']);
  }, [data]);

  return (
    <SlideRightDialog isOpen={isOpen} onClose={onClose}>
      <div className="displayFlexColumn" style={{ gap: '24px' }}>
        <div className="displayFlexColumn" style={{ gap: '8px' }}>
          <Typography variant="body2Bold" color="Primary-500">
            {t('detail.title')}
          </Typography>
          <Typography variant="subtitleBold">
            {`${insuranceDetail?.htm038 || ''} (${
              relationList.find(option => option.value === insuranceDetail?.htm002)?.label || ''
            })`}
          </Typography>
        </div>
        <div className="displayFlexColumn" style={{ gap: '16px' }}>
          {inputList.map(item => (
            <TextField
              label={item.label}
              key={item.key}
              size="small"
              color={item.color}
              variant={item.variant}
              value={formatNumber(item.key == 'total' ? total : data[item.key])}
              onChange={e => handleChange(e, item.key)}
              //장애일때만 국세청외 - 장애 입력
              disabled={item.disabled || (item.key == 'htm019' && data.htm004 != '1')}
              inputStyle={{
                backgroundColor: item.color == 'secondary' ? 'var(--Primary-100)' : '',
              }}
            />
          ))}
        </div>
        <DetailButtonSection onSave={handleSave} onClose={onClose} />
      </div>
    </SlideRightDialog>
  );
};

export default InsuranceDetail;
